export default __webpack_public_path__ + "static/media/miezeLeftPaw.a9251755.png";